const CUOTA_API_URL = 'https://rws.rodelag.com/';
const CUOTA_API_TOKEN = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHAiOiJTaG9waWZ5IiwidXN1YXJpbyI6InJvZGVsYWcifQ.DJnKY125_qWfyrnjCE35yfGtIJBGZW_GO68EUK3VaCA';

const INVALID_CUOTA_VALUES = new Set(['0', '0.0', '0.00', 'null', 'Null', 'NULL', '']);

function buildCuotaQuery(sku) {
  return JSON.stringify({
    query: `query {
      middleware_productos(cursor: 0, limite: 1, busqueda: { itemNumber: { eq: "${sku}" } }) {
        productos {
          precioTarjetaCuota
        }
      }
    }`,
  });
}

async function fetchCuota(sku) {
  const response = await fetch(CUOTA_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: CUOTA_API_TOKEN,
    },
    body: buildCuotaQuery(sku),
  });

  if (!response.ok) throw new Error(`API error ${response.status}`);

  const json = await response.json();
  const productos = json?.data?.middleware_productos?.productos;
  if (!productos?.length) return null;

  const raw = productos[0].precioTarjetaCuota;
  return INVALID_CUOTA_VALUES.has(String(raw).trim()) ? null : raw;
}

class ProductCuota extends HTMLElement {
  connectedCallback() {
    this.amountEl = this.querySelector('[data-cuota-amount]');
    this.sku = this.dataset.sku;

    this.load(this.sku);

    subscribe('variant-change', ({ data }) => {
      const newSku = data?.variant?.sku;
      if (newSku && newSku !== this.sku) {
        this.sku = newSku;
        this.load(this.sku);
      }
    });
  }

  async load(sku) {
    if (!sku) {
      this.hidden = true;
      return;
    }

    this.amountEl.classList.add('product-cuota__amount--loading');

    try {
      const cuota = await fetchCuota(sku);
      if (cuota) {
        this.amountEl.textContent = `$${cuota}`;
        this.amountEl.classList.remove('product-cuota__amount--loading');
        this.hidden = false;
      } else {
        this.hidden = true;
      }
    } catch {
      this.hidden = true;
    }
  }
}

customElements.define('product-cuota', ProductCuota);
